import axios from 'axios'
import { toast } from 'theme/modules/notifications'

const axiosInstace = axios.create({
  baseURL: process.env.VUE_APP_MAGENTO,
  headers: {
    'Authorization': `Bearer ${process.env.VUE_APP_MAGENTO_TOKEN}`
  }
})

axiosInstace.interceptors.response.use(function (response) {
  return response
}, function (error) {
  // Do something with response error
  let status = error.status || error.response.status
  // using custom errors
  // 410 -> adminUser token expire
  if (status === 410) {
    return global.$store.dispatch('userAdmin/logout')
      .then(() => {
        return Promise.reject(error)
      })
  } else {
    return global.$store.dispatch('cart/empty')
      .then(() => {
        let message = global.$i18n.t('GenericError')
        if (error.message) {
          message = error.message
        }
        if (error && error.response && error.response.data && error.response.data.message) {
          message = global.$i18n.t(error.response.data.message)
        }
        toast.error(message)
        return true
      })
      .then(() => {
        return Promise.reject(error)
      })
      .finally(() => {
        global.$router.push({ name: 'home' })
      })
  }
  // switch (status) {
  //   case 410:
  //   case 400:
  //   case 401:
  //   case 402:
  //   case 403:
  //   case 404:
  //     return global.$store.dispatch('cart/empty')
  //       .then(() => {
  //         let message = global.$i18n.t('GenericError')
  //         if (error.message) {
  //           message = error.message
  //         }
  //         if (error && error.response && error.response.data && error.response.data.message) {
  //           message = global.$i18n.t(error.response.data.message)
  //         }
  //         toast.error(message)
  //         return true
  //       })
  //       .then(() => {
  //         return Promise.reject(error)
  //       })
  //       .finally(() => {
  //         global.$router.push({ name: 'home' })
  //       })
  //   default:
  //     return Promise.reject(error)
  // }
})

export function setToken (tokenId) {
  axiosInstace.defaults.headers.Authorization = `Bearer ${tokenId || process.env.VUE_APP_MAGENTO_TOKEN}`
}

export default axiosInstace
